/**
 * ClinicCard — блок тарифа клиники (модель «пакеты»): каркас-секция +
 * переключение просмотр/правка. Разметка режимов — в ClinicView/ClinicEditor.
 * `calc` (число врачей калькулятора) держим здесь, чтобы жил между режимами.
 */

import {useState} from 'react';
import {Building2} from 'lucide-react';

import type {ClinicTariff, SaveClinicInput} from '@services/tariffs';
import {Button} from '@components/ui/Button';

import {tariffVersionLine} from '../Tariffs.utils';
import {TariffSection} from '../TariffSection';

import {ClinicEditor} from './ClinicEditor';
import {ClinicView} from './ClinicView';

type ClinicCardProps = {
  clinic: ClinicTariff;
  editing: boolean;
  onEdit: () => void;
  onCancel: () => void;
  onAskSave: (input: SaveClinicInput) => void;
};

export const ClinicCard = ({clinic, editing, onEdit, onCancel, onAskSave}: ClinicCardProps) => {
  const [calc, setCalc] = useState(6);

  return (
    <TariffSection
      icon={<Building2 className="size-[23px]" strokeWidth={1.7} />}
      iconClassName="bg-skr-icon-bg text-muted-foreground"
      title="Клиника"
      subtitle="Пакеты по числу врачей · админ бесплатно · минимум 2 места"
      version={tariffVersionLine(clinic.version, clinic.updatedAt)}
      action={
        editing ? undefined : (
          <Button variant="outline" size="sm" className="h-9 px-3.5" onClick={onEdit}>
            Изменить пакеты
          </Button>
        )
      }
    >
      {editing ? (
        <ClinicEditor
          packages={clinic.packages}
          overPrice={clinic.overPrice}
          calc={calc}
          setCalc={setCalc}
          onCancel={onCancel}
          onAskSave={onAskSave}
        />
      ) : (
        <ClinicView clinic={clinic} calc={calc} setCalc={setCalc} />
      )}
    </TariffSection>
  );
};
